import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-1959" data-mp="9wsbskew6ft4">
      <About data-id="element-1960" data-mp="9w0gzbt4cm3w" />
    </main>;
}